import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { deleteNewNote } from "../../../../redux/statementReducer/actionsStatement";
import { deleteNewNoteAccident } from "../../../../redux/TransportAccidentsReportReducer/actionsTransportAccidentsReport";
import { deleteNewTechExamTableInfo } from "../../../../redux/TechnicalExaminationReducer/actionsTechnicalExamination";

import styles from "./tableAppBoatRegRHF.module.css";
import UniversalModalWindow from "../../../GeneralComponents/universalModalWindow/UniversalModalWindow";
import {
  filterOptionsValidityMonths,
  optionsValidityMonths,
} from "../../technicalExaminationAppRHF/TableOptions";

export default function TableAppBoatRegRHF({
  appData,
  updateData,
  tableOptions,
  mainData,
  dataForTable,
  typeTable,
  mode,
  canAddInfo,
  addAccess,
  tooltipText,
  error,
  buttonText,
  setDefaultOptions,
  handleAdditionalAction,
}) {
  const [showModal, setShowModal] = useState(false);
  const [dataForEdit, setDataForEdit] = useState({});
  const [modalWindowInputs, setModalWindowInputs] = useState(null);
  const dispatch = useDispatch();

  const dataReg = useSelector((state) => {
    const { statementReducer } = state;
    return statementReducer[typeTable];
  });
  const dataDuplicate = useSelector((state) => {
    const { DuplicateShipsTicketReducer } = state;
    return DuplicateShipsTicketReducer[typeTable];
  });
  const dataShipsTicket = useSelector((state) => {
    const { ShipsTicketReducer } = state;
    return ShipsTicketReducer[typeTable];
  });

  const dataTransportAccidents = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer[typeTable];
  });
  const dataTechnicalExamination = useSelector((state) => {
    const { TechnicalExaminationReducer } = state;
    return TechnicalExaminationReducer[typeTable];
  });

  const data = !!dataForTable
    ? dataForTable
    : window.location.pathname.includes("smallboatsreg")
    ? [...dataReg]
    : window.location.pathname.includes("dupshipsticket")
    ? [...dataDuplicate]
    : window.location.pathname.includes("transportaccidents")
    ? [...dataTransportAccidents]
    : window.location.pathname.includes("techexamination")
    ? [...dataTechnicalExamination]
    : [...dataShipsTicket];

  const removeEngine = (e) => {
    e.preventDefault();
    updateData(tableOptions.keyTable, e.target.id, "removeEngine");
  };
  const handleDeleteNote = (e) => {
    e.preventDefault();
    if (!window.location.pathname.includes("reginformationchanges")) {
      let noteForDelete;
      switch (tableOptions.keyTable) {
        case "boatCardAppEngDtoList":
          noteForDelete = {
            id: e.target.id,
            type: "boatCardAppEngDtoList",
          };
          dispatch(deleteNewNote(noteForDelete));
          break;
        case "boatCardAppEngStaticDtoList":
          noteForDelete = {
            id: e.target.id,
            type: "boatCardAppEngStaticDtoList",
          };
          dispatch(deleteNewNote(noteForDelete));
          break;
        case "boatCardAppSmDtoList":
          noteForDelete = {
            id: e.target.id,
            type: "boatCardAppSmDtoList",
          };
          dispatch(deleteNewNote(noteForDelete));
          break;
        case "boatCardAppDealsDtoList":
          noteForDelete = {
            id: e.target.id,
            type: "boatCardAppDealsDtoList",
          };
          dispatch(deleteNewNote(noteForDelete));
          break;
        case "causersList":
          noteForDelete = {
            id: e.target.id,
            type: "causersList",
            mode: mode,
          };
          dispatch(deleteNewNoteAccident(noteForDelete));
          break;
        case "victimsList":
          noteForDelete = {
            id: e.target.id,
            type: "victimsList",
            mode: mode,
          };
          dispatch(deleteNewNoteAccident(noteForDelete));
          break;
        case "boatTo":
          setDataForEdit({});
          dispatch(deleteNewTechExamTableInfo(e.target.id));
          break;
        default:
          break;
      }
    } else {
      updateData(tableOptions.keyTable, e.target.id, "delete");
    }
  };

  const handleEditNote = (e) => {
    e.preventDefault();
    setDataForEdit({
      ...data.find((item) => item.innerId === e.target.id || item.id === Number(e.target.id)),
    });
    setShowModal(!showModal);
  };

  useEffect(() => {}, [data, mode]);

  return (
    <>
      {tableOptions && (
        <div
          className={styles["content-container"]}
          key={tableOptions.keyTable}>
          <p className={styles["container-description"]}>
            {tableOptions.caption}
            {tableOptions.required && mode !== "view" && <span className={styles["red"]}>*</span>}
          </p>
          <div className={styles["add-button-container"]}>
            {((canAddInfo === undefined && mode !== "view") ||
              (!!canAddInfo && canAddInfo && mode !== "view")) &&
              addAccess && (
                <div
                  id="save"
                  className={styles["save-btn"]}
                  onClick={() => setShowModal(true)}>
                  <span className={styles["plus-icon"]}></span>
                  <span>{buttonText || "Добавить"}</span>
                </div>
              )}
            {tooltipText && <p className={styles["tooltip-text"]}>{tooltipText}</p>}
          </div>

          <table className={styles["table-container"]}>
            <thead>
              <tr>
                {Object.values(tableOptions.nameColumn).map((item) => {
                  return (
                    <th
                      key={item.key}
                      id={item.key}>
                      {item.value}
                    </th>
                  );
                })}
                {data.length > 0 && mode !== "view" && <th className={styles.edit__column}>Действия</th>}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 &&
                data.map((elem) => {
                  return (
                    <tr key={elem.innerId || elem.id}>
                      {Object.values(tableOptions.nameColumn).map((item) => {
                        switch (item.type) {
                          case "checkbox":
                            return (
                              <td key={item.key}>
                                {elem.asmLock || elem.msmLock ? "Да" : "Нет"}
                                {/* <input
                              type="checkbox"
                              className={styles["checkbox"]}
                              checked={elem.asmLock || elem.msmLock}
                              disabled
                            /> */}
                              </td>
                            );
                          case "date":
                            return (
                              <td key={item.key}>
                                {elem[`${item.key}`]
                                  ? new Date(elem[`${item.key}`]).toLocaleDateString()
                                  : ""}
                              </td>
                            );
                          default:
                            switch (item.key) {
                              case "engtype":
                                const engineType = item.selectOptions.filter(
                                  (el) => el.value === elem[`${item.key}`],
                                );
                                return (
                                  <td key={item.key}>
                                    {Boolean(engineType.length) ? engineType[0].label : ""}
                                  </td>
                                );
                              case "dateRegEnd":
                                if (
                                  mode !== "view" &&
                                  Boolean(elem["dateReg"]) &&
                                  !Boolean(elem[`${item.key}`])
                                ) {
                                  return (
                                    <td key={item.key}>
                                      <button
                                        className={`${styles["button-remove-engine"]} `}
                                        id={elem.engid}
                                        onClick={(e) => removeEngine(e)}>
                                        снять
                                      </button>
                                    </td>
                                  );
                                } else {
                                  return <td key={item.key}>{elem[item.key]}</td>;
                                }
                              case "drunk":
                                return (
                                  <td key={item.key}>
                                    {elem[`${item.key}`] === "true" || elem[`${item.key}`] === true
                                      ? "Да"
                                      : "Нет"}
                                  </td>
                                );
                              case "result":
                                return (
                                  <td key={item.key}>
                                    {elem[`${item.key}`] === "true" || elem[`${item.key}`] === true
                                      ? "Годное"
                                      : "Негодное"}
                                  </td>
                                );
                              case "validityMonths":
                                const selectItem = optionsValidityMonths.find(
                                  (option) =>
                                    option.value !== null && option.value === Number(elem[`${item.key}`]),
                                );
                                const selectValue = !!selectItem ? selectItem.label : "";
                                return <td key={item.key}>{selectValue}</td>;
                              case "toUserid":
                                return (
                                  <td key={item.key}>
                                    {
                                      item.selectOptions.find(
                                        (option) => option.value === Number(elem[`${item.key}`]),
                                      )?.label
                                    }
                                  </td>
                                );
                              case "recuser":
                                return (
                                  <td key={item.key}>
                                    {elem[`${item.key}`]
                                      ? item.selectOptions.find(
                                          (option) => option.value === Number(elem[`${item.key}`]),
                                        )?.label
                                      : null}
                                  </td>
                                );
                              default:
                                return <td key={item.key}>{elem[`${item.key}`]}</td>;
                            }
                        }
                      })}
                      {data.length > 0 && mode !== "view" && (
                        <td className={styles.edit__column}>
                          {elem.hasOwnProperty("innerId") || elem.hasOwnProperty("id") ? (
                            <div className={styles["actions-buttons-block"]}>
                              <div
                                className={styles["delete-button-block"]}
                                id={elem.innerId || elem.id}
                                onClick={(e) => handleEditNote(e)}>
                                <span
                                  className={styles["edit-button"]}
                                  id={elem.innerId || elem.id}
                                  onClick={(e) => handleEditNote(e)}></span>
                              </div>
                              <div
                                className={styles["delete-button-block"]}
                                id={elem.innerId || elem.id}
                                onClick={(e) => handleDeleteNote(e)}>
                                <span
                                  className={styles["delete-button"]}
                                  id={elem.innerId || elem.id}
                                  onClick={(e) => handleDeleteNote(e)}></span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {error && <div style={{ color: "#DC3545" }}>{error}</div>}
          {showModal && (
            <UniversalModalWindow
              appData={appData}
              mainData={mainData}
              setShowModal={setShowModal}
              showModal={showModal}
              modalWindowInputs={tableOptions}
              dataForCheck={data}
              updateData={updateData}
              dataForEdit={dataForEdit}
              setDataForEdit={setDataForEdit}
              setDefaultOptions={setDefaultOptions}
              handleAdditionalAction={handleAdditionalAction}
            />
          )}
        </div>
      )}
    </>
  );
}
